import React from 'react';
import Icon from '../AppIcon';

const LanguageToggle = ({ currentLanguage, onLanguageChange, isCollapsed = false }) => {
  const languages = [
    { code: 'en', label: 'English', icon: 'Globe' },
    { code: 'fr', label: 'Français', icon: 'Globe' },
    { code: 'ar', label: 'العربية', icon: 'Globe' }
  ];

  const currentLang = languages?.find(lang => lang?.code === currentLanguage);

  if (isCollapsed) {
    return (
      <div className="flex flex-col gap-1">
        {languages?.map((lang) => (
          <button
            key={lang?.code}
            onClick={() => onLanguageChange(lang?.code)}
            className={`language-toggle ${
              currentLanguage === lang?.code ? 'language-toggle-active' : ''
            } justify-center`}
            aria-label={`Switch to ${lang?.label}`}
            title={lang?.label}
          >
            <Icon name={lang?.icon} size={18} />
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <label className="text-xs text-muted-foreground px-3 font-medium">
        {currentLanguage === 'en' && 'Language'}
        {currentLanguage === 'fr' && 'Langue'}
        {currentLanguage === 'ar' && 'اللغة'}
      </label>
      <div className="flex flex-col gap-1">
        {languages?.map((lang) => (
          <button
            key={lang?.code}
            onClick={() => onLanguageChange(lang?.code)}
            className={`language-toggle ${
              currentLanguage === lang?.code ? 'language-toggle-active' : ''
            }`}
          >
            <Icon name={lang?.icon} size={18} />
            <span className="text-sm font-medium">{lang?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageToggle;